const LS = window.LS || {};

const shareSettings = {
  text: 'Я уже зажег новую звезду! Фестиваль «Новая Волна» и Одноклассники представляют голосование за молодых исполнителей!',
  link: 'https://ok.ru/app/newwave2018',
};

const presentID = 869384941404;

const mediaTopicToPublish = {
  media: [{
    type: 'text',
    text: shareSettings.text
  },
    // {
    //     "type": "photo",
    //     "list": uploadedPhotoTokens
    // },
  {
    type: 'link',
    url: shareSettings.link
  }]
};

$$('[data-share]').map((elem) => elem.addEventListener('click', (e) => {
  e.preventDefault();

  FAPI.Client.call({
    method: 'mediatopic.post',
    attachment: JSON.stringify(mediaTopicToPublish)
  }, (status) => {
    if (status !== 'ok') {
      return;
    }

    LS.postShared = true;

    hide($$('.result'));
    show($$(LS.presentSent ? '[data-shared-present-sent]' : '[data-shared]'));
  });
}));

$$('[data-send-present]').map((elem) => elem.addEventListener('click', (e) => {
  e.preventDefault();

  FAPI.Client.call({
    method: 'promo.sendPresent',
    application_key: appParams.application_key,
    format: 'json',
    session_key: appParams.session_key,
    receiver_id: appParams.logged_user_id,
    present_id: presentID
  }, (status) => {
    if (status !== 'ok') {
      return;
    }

    LS.presentSent = true;

    hide($$('.result'));
    show($$(LS.postShared ? '[data-shared-present-sent]' : '[data-present-sent]'));
  });
}));

if (localStorage.postShared && localStorage.presentSent) {
    hide($$('.result'));
    show($$('[data-shared-present-sent]'));
} else if (localStorage.postShared) {
    hide($$('.result'));
    show($$('[data-shared]'));
} else if (localStorage.presentSent) {
    hide($$('.result'));
    show($$('[data-present-sent]'));
}
